var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 93.5 93.5",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.95,
    cy: 51.4,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.95,
    cy: 56.34,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.72 43.81 5.4-4.93 2.59-2.35c4.68-4.22 7-9.94 7.09-17.51v-6.36h3.92a1.25 1.25 0 0 0 1.28-1.25v-5.41a1.25 1.25 0 0 0 -1.25-1.25h-55.58a1.25 1.25 0 0 0 -1.25 1.25v5.41a1.25 1.25 0 0 0 1.25 1.25h3.92v6.34c.09 7.55 2.42 13.27 7.1 17.48l3 2.74 5 4.56a4.57 4.57 0 0 1 1.81 3.31 4.76 4.76 0 0 1 -1.93 3.39l-7.9 7.22c-4.68 4.21-7 9.93-7.1 17.5v5.52h-3.9a1.25 1.25 0 0 0 -1.25 1.28v5.41a1.25 1.25 0 0 0 1.25 1.25h55.55a1.25 1.25 0 0 0 1.28-1.28v-5.38a1.25 1.25 0 0 0 -1.25-1.25h-3.95v-5.57c-.09-7.55-2.41-13.27-7.09-17.48l-7.91-7.23a4.71 4.71 0 0 1 -1.91-3.36 4.61 4.61 0 0 1 1.83-3.3zm-4.33 3.31a7.07 7.07 0 0 0 2.73 5.21l7.88 7.22c4.2 3.78 6.19 8.76 6.27 15.65v5.52h-42.68v-5.51c.09-6.9 2.08-11.88 6.28-15.66l7.9-7.21a7.13 7.13 0 0 0 2.75-5.25 6.88 6.88 0 0 0 -2.66-5.09l-5-4.56-3-2.74c-4.19-3.78-6.18-8.76-6.27-15.65v-6.39h42.71v6.34c-.08 6.9-2.07 11.88-6.27 15.66-.87.78-1.73 1.57-2.6 2.37l-5.43 4.97a7 7 0 0 0 -2.61 5.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.41 29a1.24 1.24 0 0 0 -.18-1.48 1.22 1.22 0 0 0 -1.47-.25c-4.93 2.51-6.78 3.45-14.43 1a20 20 0 0 0 -14.88 1 1.25 1.25 0 0 0 -.45 1.9c.48.57 11.36 11 11.46 11a5.78 5.78 0 0 1 1.4 3.31 2 2 0 0 0 2.14 1.74 1.83 1.83 0 0 0 2-1.66 6.42 6.42 0 0 1 2.2-4.11c.17-.15.87-.82 1.82-1.73 2.34-2.24 6.24-6 7.31-6.94a15.26 15.26 0 0 0 3.08-3.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.73 76.72a1.25 1.25 0 0 0 1.27 1.28h31.91a1.25 1.25 0 0 0 1.25-1.25 17.22 17.22 0 0 0 -34.43 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.bc59ea1ff12e61c8cd06a49e4ca97941.svg";
export { ForwardRef as ReactComponent };